import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/Button'

const CaseStudy = ({
  title,
  company,
  image,
  children,
  link,
  locked,
  className,
  story
}) => {
  
  let _redirLink;

  if (locked) { _redirLink = `/password-gate?redirect=${link}`} else { _redirLink = link }

  return (
    <div className={`case-study ${className}`}>
      <div className="case-study__image">
        <img src={image} alt={`${title} Screenshot`} />
      </div>

      <div className="case-study__content">
        <header className="case-study__header">
          <h3 className="case-study__company">{company}</h3>
          <h2 className="case-study__title">{title}</h2>
        </header>
        <div className="case-study__body">{story}</div>

      <Button className="case-study__button" to={_redirLink} fancy>Read case study</Button>
      </div>
    </div>
  );
};

CaseStudy.propTypes = {
  title: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  locked: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
};

export default CaseStudy;
